import type { SponsoFee, SponsoFeesMap } from 'state/quotes/sponsoFees/sponsoFees';

export function getSponsoFees(state: SponsoFeesMap, quoteId: string | undefined): Partial<SponsoFee> | undefined {
  return quoteId ? state[quoteId] : undefined;
}
